import React, { useState } from "react";
import { Table } from "react-bootstrap";

const SummaryOfTeaSoldDataTable = ({ getSummaryOfTeaSoldDataResponse }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return getSummaryOfTeaSoldDataResponse;
    const sorted = [...getSummaryOfTeaSoldDataResponse].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [getSummaryOfTeaSoldDataResponse, sortConfig]);

  return (
    <div className="TableBox">
      <Table striped bordered hover>
        <thead>
          <tr>
            {getSummaryOfTeaSoldDataResponse != null ? (
              <>
                <th onClick={() => handleSort("lotNo")}>Lot No.</th>
                <th onClick={() => handleSort("mark")}>Mark</th>
                <th onClick={() => handleSort("grade")}>Grade</th>
                <th onClick={() => handleSort("noOfPackages")}>Pkgs</th>
                <th onClick={() => handleSort("closingPrice")}>
                  Sold Price
                </th>
                <th onClick={() => handleSort("winningBuyer")}>Bidder</th>
              </>
            ) : (
              <>
                <th>Lot No.</th>
                <th>Mark</th>
                <th>Grade</th>
                <th>Pkgs</th>
                <th>Sold Price</th>
                <th>Bidder</th>
              </>
            )}
          </tr>
        </thead>

        <tbody>
          {getSummaryOfTeaSoldDataResponse != null ? (
            <>
              {sortedData &&
                sortedData.map((teaSoldData, teaSoldDataIndex) => (
                  <tr>
                    <td>{teaSoldData.lotNo}</td>
                    <td>{teaSoldData.mark}</td>
                    <td>{teaSoldData.grade}</td>
                    <td>{teaSoldData.noOfPackages}</td>
                    <td>{teaSoldData.closingPrice}</td>
                    <td>{teaSoldData.winningBuyer}</td>
                  </tr>
                ))}
            </>
          ) : (
            "No data available"
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default SummaryOfTeaSoldDataTable;
